export default "__VITE_ASSET__ed195d01__"